<template>
  <validation-observer ref="refFormObserver">
    <b-form>
      <div class="p-1 rounded border-content">
        <p class="h5 lead">Video en vivo</p>
        <b-row class="justify-content-center">
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              :name="$t('live_profile')"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('vxg_camera.main_transmission')"
                label-for="live_profile"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  label="name"
                  v-model="itemEdit.live_profile"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="profiles"
                  :clearable="false"
                  :reduce="(val) => val.profile"
                  input-id="live_profile"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <table class="table table-sm">
          <thead>
            <tr>
              <th class="text-center">
                {{ $t('vxg_camera.video_encoder') }}
              </th>
              <th class="text-center">
                {{ $t('camera_proxy.resolution') }}
              </th>
              <th class="text-center">
                {{ $t('camera_proxy.frame_rate') }}
              </th>
              <th class="text-center">
                {{ $t('vxg_camera.bitrate') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">
                {{ liveProfileSelected.encoding_type }}
              </td>
              <td class="text-center">
                {{ liveProfileSelected.resolution }}
              </td>
              <td class="text-center">
                {{ liveProfileSelected.frame_rate }}
              </td>
              <td class="text-center">
                {{ liveProfileSelected.bitrate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="p-1 rounded border-content mt-1">
        <p class="h5 lead">Video grabado</p>
        <b-row class="justify-content-center">
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              :name="$t('recording_profile')"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('vxg_camera.live_broadcast')"
                :label-for="`recording_profile`"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  label="name"
                  v-model="itemEdit.recording_profile"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="profiles"
                  :clearable="false"
                  :reduce="(val) => val.profile"
                  input-id="live_broadcast"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <table class="table table-sm">
          <thead>
            <tr>
              <th class="text-center">
                {{ $t('vxg_camera.video_encoder') }}
              </th>
              <th class="text-center">
                {{ $t('camera_proxy.resolution') }}
              </th>
              <th class="text-center">
                {{ $t('camera_proxy.frame_rate') }}
              </th>
              <th class="text-center">
                {{ $t('vxg_camera.bitrate') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">
                {{ recordedProfileSelected.encoding_type }}
              </td>
              <td class="text-center">
                {{ recordedProfileSelected.resolution }}
              </td>
              <td class="text-center">
                {{ recordedProfileSelected.frame_rate }}
              </td>
              <td class="text-center">
                {{ recordedProfileSelected.bitrate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="p-1 rounded border-content mt-1">
        <p class="h5 lead">Control remoto</p>
        <b-row class="justify-content-center">
          <b-col cols="6">
            <validation-provider
              #default="validationContext"
              name="remote_profile"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                label="Transmisión de control remoto"
                label-for="remote_profile"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  label="name"
                  v-model="itemEdit.remote_profile"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="profiles"
                  :clearable="false"
                  :reduce="(val) => val.profile"
                  input-id="remote_profile"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <table class="table table-sm">
          <thead>
            <tr>
              <th class="text-center">
                {{ $t('vxg_camera.video_encoder') }}
              </th>
              <th class="text-center">
                {{ $t('camera_proxy.resolution') }}
              </th>
              <th class="text-center">
                {{ $t('camera_proxy.frame_rate') }}
              </th>
              <th class="text-center">
                {{ $t('vxg_camera.bitrate') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">
                {{ remoteProfileSelected.encoding_type }}
              </td>
              <td class="text-center">
                {{ remoteProfileSelected.resolution }}
              </td>
              <td class="text-center">
                {{ remoteProfileSelected.frame_rate }}
              </td>
              <td class="text-center">
                {{ remoteProfileSelected.bitrate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
// Resto de las importaciones
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import SelectPaginate from "@/views/components/SelectPaginate.vue";
import { ref, computed } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { forIn } from "lodash";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SelectPaginate,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propResData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propStreamData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemEdit: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();

    const current = computed(() => store.getters["hanwha_camera/getCurrent"]);
    const availables = computed(() => store.getters["hanwha_camera/getAvailables"]);
    const setup = computed(() => store.getters["hanwha_camera/getSetup"]);
    const profiles = computed(() => props.itemEdit.profiles || []);

    const itemData = ref({
      live_profile: "",
      recording_profile: "",
      transmission: "",
      video_encoder: "",
      resolution: "",
      frame_rate: 0,
      bitrate: 0,
      vbr: false,
      bitrate_editable: false,
    });

    const isDataModified = ref(false);
    const isInitialSetupComplete = ref(false);

    const videoEncoderOptions = ref([]);
    const videoResolutionsOptions = ref([]);
    const frameOptions = ref([]);
    const BitrateOptions = ref([]);
    const findProfile = (profile) => {
      if (profile === null || profile === undefined || profile === "") return {};
      return profiles.value.find(p => String(p.profile) === String(profile)) || {};
    };
    const liveProfileSelected = computed(() => findProfile(props.itemEdit.live_profile));
    const recordedProfileSelected = computed(() => findProfile(props.itemEdit.recording_profile));
    const remoteProfileSelected = computed(() => findProfile(props.itemEdit.remote_profile));

    const validateStep = () => {
      return true;
      //return refFormObserver.value.validate();
    };

    const range = (start, end) => {
      const arr = [];
      for (let i = start; i <= end; i++) {
        arr.push(i);
      }
      return arr;
    };

    const setInitialStreamValues = () => {
      itemData.value.live_profile = current.value.LiveProfile;
      itemData.value.recording_profile = current.value.RecordProfile;
      itemData.value.transmission = availablesOptions[0];
      itemData.value.video_encoder = availables.value[0].format;
      itemData.value.resolution = `${availables.value[0].width}x${availables.value[0].height}`;
      itemData.value.frame_rate = availables.value[0].fps;
      itemData.value.bitrate = availables.value[0].bitrate;
      itemData.value.vbr = availables.value[0].vbr;
      itemData.value.bitrate_editable = availables.value[0].bitrate_editable;

      videoEncoderOptions.value = setup.value.map((setup) => ({
        value: setup.format,
        label: setup.format,
      }));

      let setupSelected = setup.value.find(
        (setup) => setup.format == availables.value[0].format
      );

      videoResolutionsOptions.value = setupSelected.params.map((param) => ({
        value: `${param.width}x${param.height}`,
        label: `${param.width}x${param.height}`,
      }));

      let paramsSelected = setupSelected.params.find(
        (param) =>
          param.height == availables.value[0].height &&
          param.width == availables.value[0].width
      );

      frameOptions.value = range(1, paramsSelected.max_fps / 1000);

      if (availables.value[0].vbr)
        BitrateOptions.value = range(
          paramsSelected.min_vbr_bitrate,
          paramsSelected.max_vbr_bitrate
        );
      else
        BitrateOptions.value = range(
          paramsSelected.min_cbr_bitrate,
          paramsSelected.max_cbr_bitrate
        );
    };

    const handleInputChange = (field, value,) => {
      emit("update:itemData", itemData.value);
    };

    const handleTransmissionChange = (value) => {
      itemData.value.video_encoder = availables.value[value].format;
      itemData.value.resolution = `${availables.value[value].width}x${availables.value[value].height}`;
      itemData.value.frame_rate = availables.value[value].fps;
      itemData.value.bitrate = availables.value[value].bitrate;
      itemData.value.vbr = availables.value[value].vbr;
      itemData.value.bitrate_editable = availables.value[value].bitrate_editable;
      handleInputChange();
    };

    const handleCodecChange = (value) => {
      let setupSelected = setup.value.find((setup) => setup.format == value);

      videoResolutionsOptions.value = setupSelected.params.map((param) => ({
        value: `${param.width}x${param.height}`,
        label: `${param.width}x${param.height}`,
      }));

      let resolutionSplit = itemData.value.resolution.split('x')

      let paramsSelected = setupSelected.params.find(
        (param) =>
          param.height == resolutionSplit[0] &&
          param.width == resolutionSplit[1]
      );

      if (!paramsSelected) paramsSelected = setupSelected.params[0]

      frameOptions.value = range(1, paramsSelected.max_fps / 1000);

      if (availables.value[0].vbr)
        BitrateOptions.value = range(
          paramsSelected.min_vbr_bitrate,
          paramsSelected.max_vbr_bitrate
        );
      else
        BitrateOptions.value = range(
          paramsSelected.min_cbr_bitrate,
          paramsSelected.max_cbr_bitrate
        );
      handleInputChange();
    };

    const handleResolutionChange = (value) => {
      let setupSelected = setup.value.find((setup) => setup.format == itemData.value.video_encoder);

      let resolutionSplit = value.split('x')
      let paramsSelected = setupSelected.params.find(
        (param) =>
          param.height == resolutionSplit[0] &&
          param.width == resolutionSplit[1]
      );

      frameOptions.value = range(1, paramsSelected.max_fps / 1000);

      if (availables.value[0].vbr)
        BitrateOptions.value = range(
          paramsSelected.min_vbr_bitrate,
          paramsSelected.max_vbr_bitrate
        );
      else
        BitrateOptions.value = range(
          paramsSelected.min_cbr_bitrate,
          paramsSelected.max_cbr_bitrate
        );
      handleInputChange();
    };

    let availablesOptions = availables.value.map((available) => ({
      value: available.profile,
      label: available.name,
    }));

    return {
      t,
      refFormObserver,
      getValidationState,
      validateStep,
      itemData,
      handleInputChange,

      current,
      availables,
      setup,
      liveProfileSelected,
      recordedProfileSelected,
      remoteProfileSelected,

      availablesOptions,
      handleTransmissionChange,

      videoEncoderOptions,
      frameOptions,
      BitrateOptions,
      videoResolutionsOptions,
      profiles,

      handleCodecChange,
      handleResolutionChange
    };
  },
};
</script>
<style scoped>
.mx-0 {
  display: flex;
  align-items: center;
}

.border-content {
  border: 1px solid rgba(0, 0, 0, .125);
}

</style>
